import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = ({ title, subtitle, hasSearchBar = false }) => {
  const paddingClass = hasSearchBar ? "p-3" : "p-2";
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  var channelConfig = JSON.parse(localStorage.getItem("channelConfig")) || [];
  const channelDetails = {
      channal_id: channelConfig.length > 0 ? channelConfig[0].channel_id || 0 : 0,
      label: channelConfig.length > 0 ? channelConfig[0].channel_name || "" : "",
      value: channelConfig.length > 0 ? channelConfig[0].channel_id || 0 : 0,
  };

  const isNotSuperAdmin = localStorage.getItem("superadmin") &&  localStorage.getItem("role_id") !== "7";

  return (
    <div className={`dashboard-header d-flex justify-content-between align-items-center ${paddingClass}`}>
      <div className="d-flex flex-column align-items-start">
        {title ? (
          <>
            <p className="fs-2">{title}</p>
            <h1 className="fs-6">{subtitle}</h1>
          </>
        ) : (
          <h1 className="fs-6">{subtitle}</h1>
        )}
      </div>
      {isNotSuperAdmin  && (
      <div className="custom-dropdown-wrapper" ref={dropdownRef}>
        <button
          className="custom-dropdown-button"
          onClick={toggleDropdown}
          type="button"
        >
          Quick Links
          <span className="custom-dropdown-arrow">
            <svg 
              width="12" 
              height="8" 
              viewBox="0 0 12 8" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L6 6L11 1" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </span>
        </button>
        <div className={`custom-dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
          <Link to={{ pathname: "/shows/add", state: { channel: channelDetails } }} className="custom-dropdown-item">Add Show</Link>
          <Link to={{ pathname: "/videos/add", state: { show_id: 0, channel: channelDetails } }} className="custom-dropdown-item">Add Video</Link>
          <Link to={{ pathname: "/linearEvent/add", state: { channel: channelDetails } }} className="custom-dropdown-item">Create Live Event</Link>
          <Link to="/linearChannel/list" className="custom-dropdown-item">Fast Channels</Link>
          <Link to="/operations/UserManagment" className="custom-dropdown-item">User List</Link>
        </div>
      </div>
      )}
    </div>
  );
};

export default Header;